import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  fill?: string;
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ChevronLeftIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ChevronLeftIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M15.5659 20.001C15.3438 20.001 15.1216 19.9162 14.952 19.7466L7.82028 12.6148C7.48113 12.2757 7.48113 11.7263 7.82028 11.3871L14.952 4.25534C15.2912 3.91619 15.8406 3.91619 16.1798 4.25534C16.5189 4.59449 16.5189 5.14392 16.1798 5.48307L9.66187 12.001L16.1798 18.5189C16.5189 18.858 16.5189 19.4075 16.1798 19.7466C16.0102 19.9162 15.788 20.001 15.5659 20.001Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ChevronLeftIcon;
